// extracted by mini-css-extract-plugin
module.exports = {"cart__title":"emptyCart_cart__title__rN3M_","cart__links":"emptyCart_cart__links__V3ikw","cart__linkButton":"emptyCart_cart__linkButton__atfSC"};